import React from "react";
import FeedbackListSection from "./components/feedback-list-section";

/**
 * Feedbacks Module
 *
 * Main component for the Feedbacks module that displays a list of feedbacks
 * and provides navigation to add new feedbacks.
 */
const Feedbacks: React.FC = () => {
  return (
    <div className="h-full flex flex-col gap-6">
      {/* Student Logs List - Takes remaining height */}
      <div className="h-full">
        <FeedbackListSection />
      </div>
    </div>
  );
};

export default Feedbacks;
